module.exports = __webpack_public_path__ + "4-77.jpg?d8edada70333c23d13b6e6e3352363a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-77.jpg
// module id = 158
// module chunks = 0